import { CheckCircleOutlined, EditOutlined, StopOutlined } from "@ant-design/icons";
import { PageHeader, Popconfirm, Tag, Tooltip, message } from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import { ButtonItem, SegmentedItem, TableItemDinamico } from "../../../Components/Items";
import moment from "moment";
import "moment/locale/es";
import AgregarDepartamento from "./AgregarDepartamento/AgregarDepartamento";
import EditarDepartamento from "./EditarDepartamento/EditarDepartamento";

moment.locale("es");

class Departamentos extends Component {
    tableRef = null;
    state = {
        todasDepartamentos: [],
        loading: false,
        valor: 1,
        modalAgregarDepartamento: false,
        modalEditarDepartamento: false,
        modalEditarDepartamentoId: null,
    };
    consultarDepartamentos(params) {
        this.setState({ loading: true });
        axios
            .post(
                "departamentos/selectTodasDepartamentos",
                { empresaId: this.props.empresaId, ...params },
                {
                    headers: this.props.headersToken,
                }
            )
            .then((res) => {
                this.setState({ loading: false });
                if (res.data.success !== 2) {
                    this.setState({ todasDepartamentos: [] });
                } else {
                    this.setState({
                        todasDepartamentos: res.data.data,
                        totalRecords: res.data.totalRecords || 0,
                    });
                }
            });
    }

    deshabilitarDepartamento(value) {
        this.setState({ loading: true });
        axios
            .post(
                "departamentos/deshabilitarDepartamento",
                { departamentoId: value, empresaId: this.props.empresaId },
                { headers: this.props.headersToken }
            )
            .then((res) => {
                if (res.data.success === 2) {
                    message.success("Departamento deshabilitado");
                } else {
                    message.error("Sucedio un error y no se pudo deshabilitar");
                }
                if (this.tableRef) {
                    this.tableRef.updateExternalFilters({ valor: this.state.valor });
                }
            });
    }
    habilitarDepartamento(value) {
        this.setState({ loading: true });
        axios
            .post(
                "departamentos/habilitarDepartamento",
                { departamentoId: value, empresaId: this.props.empresaId },
                { headers: this.props.headersToken }
            )
            .then((res) => {
                if (res.data.success === 2) {
                    message.success("Departamento habilitado");
                } else {
                    message.error("Sucedio un error y no se pudo habilitar");
                }
                if (this.tableRef) {
                    this.tableRef.updateExternalFilters({ valor: this.state.valor });
                }
            });
    }

    agregarDepartamento() {
        this.setState({ modalAgregarDepartamento: true });
    }
    cerrarAgregarDepartamento() {
        this.setState({ modalAgregarDepartamento: false });
        this.tableRef.updateExternalFilters({ valor: this.state.valor });
    }
    editarDepartamento(id) {
        this.setState({ modalEditarDepartamento: true, modalEditarDepartamentoId: id });
    }
    cerrarEditarDepartamento() {
        this.setState({ modalEditarDepartamento: false });
        this.tableRef.updateExternalFilters({ valor: this.state.valor });
    }

    render() {
        const columns = [
            {
                title: "Número",
                dataIndex: "numero",
                key: "numero",
                buscar: "serieNumero",
                render: (value,record) => `${record.serie} - ${record.numero}`,
                width: "6%",
            },
            {
                title: "Nombre",
                dataIndex: "nombre",
                key: "nombre",
                buscar: "nombre",
                width: "13%",
            },
            {
                title: "Descripción",
                dataIndex: "descripcion",
                key: "descripcion",
                buscar: "descripcion",
                width: "18%",
            },
            {
                title: "Estado",
                dataIndex: "estado",
                key: "estado",
                width: "8%",
                render: (value) => {
                    if (value === 0) return <Tag color="red">Cancelado</Tag>;
                    if (value === 1) return <Tag color="green">Activo</Tag>;
                    if (value === 2) return <Tag color="orange">Deshabilitado</Tag>;
                    return "—";
                },
            },
            {
                title: "Acción",
                dataIndex: "accion",
                key: "accion",
                width: "10%",
                render: (value, record) => {
                    let buttons = [];

                    if (this.props.permisoEditarDepartamentos) {
                        buttons.push(
                            <Tooltip
                                title="Editar Departamento"
                                placement="top"
                                overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}
                            >
                                <ButtonItem
                                    key={`editar-${record._id}`}
                                    type="default"
                                    size="small"
                                    cyan
                                    icon={<EditOutlined />}
                                    onClick={() => this.editarDepartamento(record._id)}
                                >
                                </ButtonItem>
                            </Tooltip>
                        );
                    }

                    if (record.estado === 1) {
                        buttons.push(
                            <Popconfirm
                                key={`deshabilitar-${record._id}`}
                                title="¿Seguro que quieres deshabilitar este departamento?"

                                onConfirm={() => this.deshabilitarDepartamento(record._id)}
                                okText="Sí"
                                cancelText="No"
                            >
                                <Tooltip
                                    title="Deshabilitar"
                                    placement="top"
                                    overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}
                                >
                                    <ButtonItem
                                        type="default"
                                        size="small"
                                        lima
                                        icon={<CheckCircleOutlined />}
                                    >
                                    </ButtonItem>
                                </Tooltip>
                            </Popconfirm>
                        );
                    } else {
                        buttons.push(
                            <Popconfirm
                                key={`habilitar-${record._id}`}
                                title="¿Seguro que quieres habilitar este departamento?"
                                onConfirm={() => this.habilitarDepartamento(record._id)}
                                okText="Sí"
                                cancelText="No"
                            >
                                <Tooltip
                                    title="Habilitar"
                                    placement="top"
                                    overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}
                                >
                                    <ButtonItem
                                        type="default"
                                        size="small"
                                        rojo
                                        icon={<StopOutlined />}
                                    >
                                    </ButtonItem>
                                </Tooltip>
                            </Popconfirm>
                        );
                    }

                    return <div className="acciones-container">{buttons}</div>;
                }
            },
        ];


        return (
            <>
                <PageHeader
                    title="Departamentos"
                    style={{
                        border: "1px solid rgb(235, 237, 240)",
                        backgroundColor: "white",
                        marginBottom: 10,
                    }}
                    extra={
                        <>
                            {window.innerWidth > 1000 &&
                                <>
                                    <SegmentedItem
                                        options={[{ label: 'Vigente', value: 1 }, { label: 'Deshabilitada', value: 2 }, { label: 'Todos', value: 3 }]}
                                        onChange={(value) => {
                                            if (this.tableRef) {
                                                this.tableRef.updateExternalFilters({ valor: value, textoFiltro: this.state.textoFiltro });
                                            }
                                            this.setState({ valor: value });
                                        }}
                                        value={this.state.valor}
                                    />
                                </>
                            }
                            {this.props.permisoAgregarDepartamentos && (
                                <ButtonItem
                                    type="primary"
                                    key="agregarDepartamento"
                                    onClick={this.agregarDepartamento.bind(this)}
                                >
                                    Agregar Departamento
                                </ButtonItem>
                            )}
                        </>
                    }
                />
                <TableItemDinamico
                    ref={(ref) => this.tableRef = ref}
                    onRef={(ref) => this.tableRef = ref}
                    totalRecords={this.state.totalRecords}
                    loading={this.state.loading}
                    onFetchData={this.consultarDepartamentos.bind(this)}
                    anadirValorFiltro={this.state.valor}
                    size="small"
                    onlyMineFilter
                    dataSource={this.state.todasDepartamentos}
                    columns={columns}
                    scroll={{ x: "max-content" }}
                    filterStorageKey={"departamentos" + this.props.empresaId}
                    onRow={(record) => ({
                        onDoubleClick: () => {
                            if (this.props.permisoEditarDepartamentos) {
                                this.editarDepartamento(record._id);
                            }
                        },
                    })}
                    setValor={(valor) => this.setState({ valor })}
                    valorDefault={1}
                />
                {this.props.permisoAgregarDepartamentos && (
                    <AgregarDepartamento
                        visible={this.state.modalAgregarDepartamento}
                        cerrarAgregarDepartamento={this.cerrarAgregarDepartamento.bind(this)}
                    />
                )}
                {this.props.permisoEditarDepartamentos && (
                    <EditarDepartamento
                        visible={this.state.modalEditarDepartamento}
                        departamentoId={this.state.modalEditarDepartamentoId}
                        cerrarEditarDepartamento={this.cerrarEditarDepartamento.bind(this)}
                    />
                )}
            </>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        headersToken: state.user.headersToken,
        empresaId: state.empresa.id,
        permisoAgregarDepartamentos:
            state.user.tipo === 0 ||
            state.user.permisos.find(
                (valueTodos) =>
                    valueTodos.permisoId.toString() === "6a96035e8b7c192b16f8abf4"
            )?.activado,
        permisoEditarDepartamentos:
            state.user.tipo === 0 ||
            state.user.permisos.find(
                (valueTodos) =>
                    valueTodos.permisoId.toString() === "6a96036c6102bd5076d2a3e1"
            )?.activado,
    };
};

export default connect(mapStateToProps)(Departamentos);
